import { defaultApi, defaultClient } from '@mint-sdk/api-core';

import {
  copyUserResponseSchema,
  copyUsersRequestSchema,
  createTagRequestSchema,
  createTagResponseSchema,
  deleteTagResponseSchema,
  getOldTagsQuerySchema,
  getOldTagsResponseSchema,
  getTagResponseSchema,
  getTagsQuerySchema,
  getTagsResponseSchema,
  getTreeDataResponseSchema,
  getTreeTagsQuerySchema,
  mediaPlanAssignTagsRequestSchema,
  mediaPlanAssignTagsResponseSchema,
  mediaPlanDismissTagsRequestSchema,
  mediaPlanDismissTagsResponseSchema,
  querySchema,
  updateTagRequestSchema,
} from '../shared/schemas/index.js';

// MINT 2.0 Tags API Endpoints

export const treeDataQueryOptions = defaultClient.query({
  url: 'bff/v2/brands_and_geo/tree/' as const,
  method: 'GET',
  responseSchema: getTreeDataResponseSchema,
  querySchema: getTreeTagsQuerySchema,
  snakeCaseQueryParams: true,
  processResponse(data) {
    return data;
  },
});

export const treeDataUserQueryOptions = defaultClient.query({
  url: 'bff/v2/brands_and_geo/tree/my' as const,
  method: 'GET',
  responseSchema: getTreeDataResponseSchema,
  querySchema: getTagsQuerySchema,
  snakeCaseQueryParams: true,
  processResponse(data) {
    return data;
  },
});

export const listQueryOptions = defaultClient.query({
  url: 'bff/v2/brands_and_geo/tags/?cache=skip' as const,
  method: 'GET',
  responseSchema: getTagsResponseSchema,
  querySchema: getTagsQuerySchema,
  snakeCaseQueryParams: true,
  processResponse(data) {
    return data;
  },
});

export const tagQueryOptions = defaultClient.query({
  url: 'bff/v2/brands_and_geo/tags/$tagId' as const,
  method: 'GET',
  responseSchema: getTagResponseSchema,
  querySchema: querySchema,
  processResponse(data) {
    return data;
  },
});

export const create = defaultApi.declareEndpoint({
  url: 'bff/v2/brands_and_geo/tags/?cache=skip' as const,
  method: 'POST',
  responseSchema: createTagResponseSchema,
  requestSchema: createTagRequestSchema,
});

export const update = defaultApi.declareEndpoint({
  url: 'bff/v2/brands_and_geo/tags/$tagId' as const,
  method: 'PATCH',
  querySchema: querySchema,
  responseSchema: createTagResponseSchema,
  requestSchema: updateTagRequestSchema,
});

export const deleteTag = defaultApi.declareEndpoint({
  url: 'bff/v2/brands_and_geo/tags/$tagId' as const,
  method: 'DELETE',
  querySchema: querySchema,
  responseSchema: deleteTagResponseSchema,
});

// MINT Tags API Endpoints
export const listOldQueryOptions = defaultClient.query({
  url: 'authentication/v1/tags/' as const,
  method: 'GET',
  responseSchema: getOldTagsResponseSchema,
  querySchema: getOldTagsQuerySchema,
  snakeCaseQueryParams: true,
  processResponse(data) {
    return data;
  },
});

export const industriesListOldQueryOptions = defaultClient.query({
  url: 'authentication/v1/industries/' as const,
  method: 'GET',
  responseSchema: getOldTagsResponseSchema,
  querySchema: getOldTagsQuerySchema,
  snakeCaseQueryParams: true,
  processResponse(data) {
    return data;
  },
});

export const copyUsers = defaultApi.declareEndpoint({
  url: 'authentication/v1/tag_assignments/copy_users/' as const,
  method: 'POST',
  responseSchema: copyUserResponseSchema,
  requestSchema: copyUsersRequestSchema,
});

export const useMediaPlanAssignTags = defaultClient.mutation({
  url: 'authentication/v1/tag_assignments/assign_campaign/',
  method: 'POST',
  responseSchema: mediaPlanAssignTagsResponseSchema,
  requestSchema: mediaPlanAssignTagsRequestSchema,
  processResponse(data) {
    return data;
  },
});

export const useMediaPlanDismissTags = defaultClient.mutation({
  url: 'authentication/v1/tag_assignments/dismiss_campaign/',
  method: 'POST',
  responseSchema: mediaPlanDismissTagsResponseSchema,
  requestSchema: mediaPlanDismissTagsRequestSchema,
  processResponse(data) {
    return data;
  },
});
